import { render, staticRenderFns } from "./ShopManage.vue?vue&type=template&id=85d5694c&scoped=true"
import script from "./ShopManage.vue?vue&type=script&lang=ts"
export * from "./ShopManage.vue?vue&type=script&lang=ts"
import style0 from "./ShopManage.vue?vue&type=style&index=0&id=85d5694c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d5694c",
  null
  
)

export default component.exports